import Phaser from 'phaser';
import Character, { preload as preloadCharacter } from '../../objects/test/Character';

export default class CharacterObject extends Phaser.Scene {
  constructor() {
    super({ key: 'CharacterObject', active: true });
  }

  preload() {
    this.load.setBaseURL('/assets/test/');

    preloadCharacter.call(this);
  }

  create() {
    this.physics.world.setBoundsCollision(true);

    new Character({
      scene: this,
      x: this.game.config.width / 2,
      y: this.game.config.height / 2,
    });
  }
}
